import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    padding: '0 24px',
  },
});

export default useStyles;
